<script lang="ts">
  export let color = '';
</script>
<div
  tabindex="0"
  role="button"
  class={`svg-icon svg-icon-close ${$$restProps.class || ''}`}
  on:click
  on:keyup={() => {}}
>
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
      <g transform="translate(-294.000000, -246.000000)" stroke={color || 'currentColor'} stroke-width="1.5">
        <g id="x" transform="translate(289.000000, 241.000000)">
          <path
            id="Combined-Shape"
            d="M23.4375,6.5625 L6.5625,23.4375 L23.4375,6.5625 Z M6.5625,6.5625 L23.4375,23.4375 L6.5625,6.5625 Z"
          />
        </g>
      </g>
    </g>
  </svg>
</div>
